import { render, staticRenderFns } from "./judge.vue?vue&type=template&id=dc74d04e"
import script from "./judge.vue?vue&type=script&lang=js"
export * from "./judge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports